import type { ToolMeta } from "../types";

export const toolMeta: ToolMeta = {
  slug: "image-to-text",
  title: "Image to Text",
  pageHeading: "Free Image to Text Converter",
  description:
    "Extract text from one or many images with browser OCR, then edit, copy, or download the results as TXT files.",
  seoTitle: "Image to Text Converter - Batch OCR to TXT",
  seoDescription:
    "Convert images, screenshots and scans to editable text with free online OCR. Process multiple images and download individual or combined TXT files.",
  featureList: [
    "Image-to-text OCR",
    "Image upload, drag-and-drop, and clipboard paste",
    "Document language selection",
    "OCR progress and confidence details",
    "Editable extracted text",
    "One-click text copy",
    "Batch OCR and TXT downloads",
  ],
  category: "Images",
} satisfies ToolMeta;
